import { setCookie } from 'tiny-cookie';

export interface AccessToken {
  token: string;
  refreshToken: string;
  expiresIn: number;
}

function jwtCookieName(): string {
  return window.__JWT_COOKIE_NAME__ || 'jwt';
}

function refreshTokenCookieName(): string {
  return window.__REFRESH_TOKEN_COOKIE_NAME__ || 'refresh_token';
}

export function setAuthCookies(accessToken: AccessToken): void {
  const domain = window.cookiesRootDomain;
  const cookieOptions: { expires: string; domain?: string } = {
    expires: `${accessToken.expiresIn}s`,
  };

  if (domain) {
    cookieOptions.domain = domain;
  }

  setCookie(jwtCookieName(), accessToken.token, cookieOptions);
  setCookie(refreshTokenCookieName(), accessToken.refreshToken, domain ? { domain } : {});
}

export function redirectToDashboard(): void {
  window.location.href = '/dashboard/#/home';
}
